import React from 'react';
import ReactDOM from 'react-dom';

const backdrop = {
  position: 'fixed',
  inset: 0,
  zIndex: 50010,
  background: 'rgba(0,0,0,0.82)',
  color: '#fff',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: 24
};

const btn = {
  background: '#1976d2',
  color: '#fff',
  border: 0,
  borderRadius: 6,
  padding: '12px 20px',
  fontSize: 16,
  cursor: 'pointer'
};

export default function SecurityBlockOverlay({
  open,
  title,
  message,
  actionLabel,
  onAction
}) {
  if (!open) return null;
  const node = (
    <div style={backdrop} role="dialog" aria-modal="true" aria-label={title || 'Secure exam paused'}>
      <div style={{ textAlign: 'center', maxWidth: 520 }}>
        <div style={{ letterSpacing: 2, fontSize: 12, textTransform: 'uppercase', opacity: 0.85 }}>
          Secure exam paused
        </div>
        <h2 style={{ margin: '12px 0' }}>{title}</h2>
        <p style={{ marginBottom: 24, lineHeight: 1.5 }}>{message}</p>
        {actionLabel && onAction ? (
          <button type="button" style={btn} onClick={onAction}>
            {actionLabel}
          </button>
        ) : null}
      </div>
    </div>
  );
  if (typeof document === 'undefined') return node;
  return ReactDOM.createPortal(node, document.body);
}
